import PropTypes from 'prop-types';
import { Box } from '@podiumhq/design-system';

const BoxWrapper = ({ marginTop = '20px', width = '100%', children }) => {
  return (
    <Box mt={marginTop} w={width}>
      {children}
    </Box>
  );
};

BoxWrapper.propTypes = {
  marginTop: PropTypes.string,
  width: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default BoxWrapper;
